import { Numeric1BoxMultipleOutlineIcon } from './Numeric1BoxMultipleOutlineIcon';

/**
 * author: Google
 * id 55513DD6-D73E-438E-8834-D6761C47BA4B
 * name numeric-1-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric1BoxesOutlineIcon = Numeric1BoxMultipleOutlineIcon;
export default Numeric1BoxesOutlineIcon